import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const BannerImageSelection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [sortNumber, setSortNumber] = useState(undefined);
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [imageId, setImageId] = useState(undefined);
  const [bannerType, setBannerType] = useState("Image"); // New state for banner type
  const [selectedVideo,setSelectedVideo]=useState()
  const [thumbnail,setThumbnail]=useState()

  const dispatch = useDispatch();

  const { banners, loading } = useSelector((state) => state.homepageSlice);

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(homepageSlice.getBannerList());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        const isUnder10MB = file.size <= 10 * 1024 * 1024; // 5 MB in bytes
        if(bannerType==="Video"&&!isUnder10MB){
          toast( 'Video file must be under 10 MB.');
        }
            const imageUrl = URL.createObjectURL(file);
            setSelectedImage(file);
            setPreviewImage(imageUrl);
          }
};



  const handleSubmit = async (event) => {
      event.preventDefault();
      const isExistSortNumber=banners?.home_background_images?.find((b)=>b?.sort_number==sortNumber);
     
      if(bannerType==="Video" && !thumbnail){
        toast("Please choose thumbnail");
        return;
      }

      if (isExistSortNumber) {
        toast("Sort number already exist");
        return;
      }

      if (!selectedImage) {
        toast(`Please select an ${bannerType==="Video"?"Video":"Image"}`);
        return;
      }

      if (!sortNumber || sortNumber === 0) {
        toast("Please enter sort number");
        return;
      }
      const formData = new FormData();
      formData.append("home_background_image", selectedImage);
      formData.append("sort_number", sortNumber);
      formData.append("banner_type", bannerType);

     if(bannerType==="Video"){    
      formData.append("thumbnail", thumbnail);
    }

      const response = await dispatch(homepageSlice.storeBanner(formData));
      await dispatch(homepageSlice.getBannerList());

      setSelectedImage(null);
      setPreviewImage(null);

      // Clear the file input box after submit
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }

      // Close the modal after submission
      setShowAddTempleModal(false);
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);

  // Handle delete
  const handleDelete = (imageId) => {
    setDeleteModal(true);
    setDeletableId(imageId);
  };

  const handleDeleteImage = async () => {
    await dispatch(homepageSlice.deleteBanner(deletableId));
    dispatch(homepageSlice.getBannerList());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Sort Number",
      selector: (row) => row?.sort_number || "-",
      sortable: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <img
          src={`${imageBaseUrl}${row?.banner_type==="Video"?row?.thumbnail:row?.image}`}
          alt={`Banner ${row.id}`}
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowEditTempleModal(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = banners?.home_background_images?.find((h) => h?.id === id);
    setImageId(data?.id);
    setSortNumber(data?.sort_number);
    setBannerType(data?.banner_type);
  };

  const editHomeBanner = async (event) => {
    event.preventDefault();

    const isExistSortNumber = banners?.home_background_images?.find((b)=>b?.sort_number==sortNumber && b?.id!==imageId);

    const data = banners?.home_background_images?.find((h) => h?.id === imageId);
    if (bannerType==="Image" && data?.image?.endsWith(".mp4") && !selectedImage) {
      toast("Choose Image");
      return;
    }

    if (isExistSortNumber) {
      toast("Sort number already exist");
      return;
    }

    if (!sortNumber || sortNumber === 0) {
      toast("Please enter sort number");
      return;
    }
    const formData = new FormData();
    // formData.append("sort_number", sortNumber);
    if (selectedImage) {
      formData.append("home_background_image", selectedImage);
    }
    formData.append("sort_number", sortNumber);
    formData.append("banner_type", bannerType);

    if(thumbnail&&bannerType==="Video"){
      formData.append("thumbnail", thumbnail);
    }
    console.log(thumbnail,sortNumber,bannerType,imageId,"payload")
    await dispatch(homepageSlice.editBanner(imageId, formData));

    setSelectedImage(null);
    setPreviewImage(null);

    // Clear the file input box after submit
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    // Close the modal after submission
    setShowEditTempleModal(false);
    await dispatch(homepageSlice.getBannerList());
  };

  return (
    <>
      <h5 className="mb-4"> Homepage Banner Image</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h6>Added Banners:</h6>
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => setShowAddTempleModal(true)}
          >
            Add Banner Image
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={banners?.home_background_images || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeleteImage}
        name={"Image"}
      />

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Banner Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>

          <Form.Group controlId="bannerType" className="mb-3">
            <Form.Label>Banner Type</Form.Label>
            <Form.Select
              value={bannerType}
              onChange={(e) => setBannerType(e.target.value)}
              required // Optional: Make this field mandatory if needed
            >
              <option value="">Select Banner Type</option>
              <option value="Image">Image</option>
              <option value="Video">Video</option>
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Select {bannerType==="Video"?"Video":"Image"}</Form.Label>
              <Form.Control
            type="file"
            accept={bannerType==="Video"?"video/*":"image/*"} // Allow both images and videos
            onChange={handleFileChange}
            ref={fileInputRef} // Bind the file input to the ref
           />
            </Form.Group>
             {bannerType==="Video"&&<Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Select Thumbnail</Form.Label>
              <Form.Control
            type="file"
            accept="image/*" // Allow both images and videos
            onChange={(e)=>setThumbnail(e.target.files[0])}
            ref={fileInputRef} // Bind the file input to the ref
           />
            </Form.Group>}

            {/* Sort Number Input */}
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Sort Number</Form.Label>
              <Form.Control
                type="number"
                value={sortNumber}
                onChange={(e) => setSortNumber(e.target.value)}
                placeholder="Enter sort number"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>

            {/* {previewImage && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{ width: "150px", height: "150px" }}
                />
              </div>
            )} */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          <Button variant="primary" type="submit" onClick={handleSubmit}>
            Save Image
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEditTempleModal}
        onHide={() => setShowEditTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Banner Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
          <Form.Group controlId="bannerType" className="mb-3">
            <Form.Label>Banner Type</Form.Label>
            <Form.Select
              value={bannerType}
              onChange={(e) => setBannerType(e.target.value)}
              required // Optional: Make this field mandatory if needed
            >
              <option value="">Select Banner Type</option>
              <option value="Image">Image</option>
              <option value="Video">Video</option>
            </Form.Select>
          </Form.Group>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Select {bannerType==="Video"?"Video":"Image"}</Form.Label>
              <Form.Control
                type="file"
                accept={bannerType==="Video"?"video/*":"image/*"}
                onChange={handleFileChange}
                ref={fileInputRef} // Bind the file input to the ref
              />
            </Form.Group>

            {bannerType==="Video"&&<Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Select Thumbnail</Form.Label>
              <Form.Control
            type="file"
            accept="image/*" // Allow both images and videos
            onChange={(e)=>setThumbnail(e.target.files[0])}
            ref={fileInputRef} // Bind the file input to the ref
           />
            </Form.Group>}

            {/* Sort Number Input */}
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Sort Number</Form.Label>
              <Form.Control
                type="number"
                value={sortNumber}
                onChange={(e) => setSortNumber(e.target.value)}
                placeholder="Enter sort number"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditTempleModal(false)}
          >
            Close
          </Button>
          <Button variant="primary" type="submit" onClick={editHomeBanner}>
            Save Image
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BannerImageSelection;
